import { render, staticRenderFns } from "./mdUserLang.vue?vue&type=template&id=2e39b38e&scoped=true&"
import script from "./mdUserLang.vue?vue&type=script&lang=js&"
export * from "./mdUserLang.vue?vue&type=script&lang=js&"
import style0 from "./mdUserLang.vue?vue&type=style&index=0&id=2e39b38e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e39b38e",
  null
  
)

export default component.exports